//export const bodyBgColor = state => state.bodyBgColor
export const navBarLink = state => state.navBarLink
export const navLink = state => state.navBarLink.navList
export const navOutsiteLink = state => state.navBarLink.outsiteLink